import * as Cookie from './cookie';

export function init(name, checkForCookie = false) {
    const municipalityModal = document.querySelector(`[data-modal="${name}"]`);
    const municipalitySelect = document.querySelector('[data-set-municipality]');
    const municipalities = ['roerdalen', 'maasgouw', 'leudal', 'echt-susteren'];
    const isGlobalPage = document.querySelector('body').classList.contains('is-global-page');

    // Set cookie when forced parameter is used
    // Also make sure the municipality is valid, to prevent random strings being stored in cookie
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('gemeente') && municipalities.includes(urlParams.get('gemeente'))) {
        Cookie.set('municipality', urlParams.get('gemeente'));
        municipalitySelect.value = urlParams.get('gemeente');
    }

    // Fix for setting the cookie
    if (municipalitySelect.value) {
        Cookie.set('municipality', municipalitySelect.value);
    }

    if (checkForCookie && !Cookie.has(name) && !isGlobalPage) {
        document.body.classList.add('overflow-hidden');
        municipalityModal.classList.remove('hidden');
        municipalityModal.setAttribute('aria-hidden', 'false');
    }

    // Prevent user from navigating outside the modal with keyboard
    if (municipalityModal) {
        municipalitySelect.focus();

        municipalityModal.querySelector('[data-confirm-municipality]').addEventListener('keydown', (e) => {
            if (e.key === 'Tab') {
                e.preventDefault();
                municipalitySelect.focus();
            }
        });
    }
}
